module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority-new/ecomm/ecomm-03-ea551d353ca14d6ec138d6bd77e4f9a8.jpg";